import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import NotificationAPI from '@/api/notification/api-notification';

export const fetchNotifications = createAsyncThunk(
  'notification/fetchNotifications',
  async (_, thunkAPI) => {
    try {
      const response = await NotificationAPI.getAll();
      return response?.data?.data ?? [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addNotification = createAsyncThunk(
  'notification/addNotification',
  async (payload, thunkAPI) => {
    try {
      const response = await NotificationAPI.add(payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateNotification = createAsyncThunk(
  'notification/updateNotification',
  async (payload, thunkAPI) => {
    try {
      const response = await NotificationAPI.update(payload.id, payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteNotification = createAsyncThunk(
  'notification/deleteNotification',
  async (ids, thunkAPI) => {
    try {
      await NotificationAPI.delete(ids);
      return ids;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  error: '',
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [...action.payload];
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.payload ?? 'An error occurred';
      })
      // .addCase(addNotification.fulfilled, (state, action) => {
      //   state.list.unshift(action.payload);
      // })
      // .addCase(updateNotification.fulfilled, (state, action) => {
      //   const index = state.list.findIndex((item) => item.id === action.payload.id);
      //   if (index !== -1) state.list[index] = action.payload;
      // })
      .addCase(addNotification.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.list = [action.payload, ...state.list]; // ensure new one is added
      })
      .addCase(updateNotification.fulfilled, (state, action) => {
        if (!action.payload) return;
        const index = state.list.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.list[index] = { ...state.list[index], ...action.payload };
        }
      })

      .addCase(deleteNotification.fulfilled, (state, action) => {
        const idsToDelete = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];
        state.list = state.list.filter(
          (item) => !idsToDelete.includes(item.id)
        );
      });
  },
});

export default notificationSlice.reducer;
